import React from 'react'

function Properties() {
  return <div>Properties</div>
}

export { Properties }
